export default "__VITE_ASSET__Cf7vm0PZ__"